angular.module('app')
  .directive('ngMatch', function ($parse) {
    return {
      require: 'ngModel',
      link: (scope, element, attrs, controller) => {
        controller.$validators.match = (modelValue) => modelValue === $parse(attrs.ngMatch)(scope);

        scope.$watch(attrs.match, () => {
          controller.$validate();
        });
      },
    };
  });
